import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Check, ShoppingCart, Truck, Receipt, Wallet } from "lucide-react";
import { api, errMsg, rp, dt } from "@/lib/api";
import { PageHeader, Card, MoneyOnly } from "@/components/common";

const META = {
  purchase: { label: "Pembelian", icon: ShoppingCart, tone: "text-indigo-600" },
  transfer: { label: "Transfer", icon: Truck, tone: "text-emerald-600" },
  expense: { label: "Biaya", icon: Receipt, tone: "text-rose-600" },
  cash: { label: "Kas", icon: Wallet, tone: "text-amber-600" },
};

export default function Review() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");
  const load = useCallback(() => api.get("/review/pending").then((r) => setRows(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const ack = async (item) => {
    setBusy(item.id);
    try {
      await api.post("/review/acknowledge", { type: item.type, id: item.id });
      toast.success("Ditandai sudah direview ✓");
      setRows((rs) => rs.filter((x) => x.id !== item.id));
    } catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  const list = rows || [];
  return (
    <div className="max-w-3xl">
      <PageHeader title="Perlu review" sub="Transaksi yang sudah diposting dan menunggu Anda tandai sudah dicek. Menandai tidak mengubah stok maupun kas." />
      {rows && list.length === 0 && <div className="text-center text-sm text-slate-500 py-16 bg-white rounded-lg border" data-testid="review-empty">Semua transaksi sudah direview. 🎉</div>}
      <div className="space-y-2.5">
        {list.map((r) => {
          const m = META[r.type] || META.cash;
          const Icon = m.icon;
          return (
            <Card key={`${r.type}-${r.id}`} className="p-4" testid={`review-item-${r.code}`}>
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <Icon size={15} className={m.tone} />
                    <span className="text-[10px] font-bold uppercase tracking-wide text-slate-400">{m.label}</span>
                    <Link to={r.link} className="num font-bold text-sm text-emerald-700 hover:underline">{r.code}</Link>
                  </div>
                  <div className="text-[13px] text-slate-700 mt-1 font-medium">{r.title}</div>
                  <div className="text-[11px] text-slate-500 mt-1"><MoneyOnly>{rp(r.value)} · </MoneyOnly>{dt(r.at)}{r.by && ` · oleh ${r.by}`}</div>
                </div>
                <button disabled={busy === r.id} onClick={() => ack(r)} data-testid={`review-ack-${r.code}`}
                  className="h-9 px-3 inline-flex items-center gap-1.5 rounded-md bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-700 disabled:opacity-50 shrink-0">
                  <Check size={15} /> Sudah direview
                </button>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
